export default __webpack_public_path__ + "static/media/03.723c4fb4.jpg";